import styles from './resources_search.module.sass'

import find from 'lodash/find'
import merge from 'lodash/merge'
import each from 'lodash/each'
import get from 'lodash/get'

import classNames from 'classnames'

import instantsearch from 'instantsearch.js'
import algoliasearch from 'algoliasearch'

import { searchBox, configure, pagination, stats } from 'instantsearch.js/es/widgets'
import { connectHits } from 'instantsearch.js/es/connectors'

import { useEffect, useRef, useState } from 'react'

import useStateRef from 'react-usestateref'

import {Swiper, SwiperSlide} from 'swiper/react'
import { Navigation, Pagination, Autoplay } from 'swiper'
import 'swiper/scss'
import 'swiper/scss/navigation'
import 'swiper/scss/pagination'
import 'swiper/scss/autoplay'

import Title from './basic/title'
import Wysiwyg from './wysiwyg'

import config from '../config'

const types = {
	all: {
		label: 'All',
		title: 'All',
		url: '/resources/',
		nid: 465
	},
	news: {
		label: 'News Center',
		title: 'News',
		url: '/resources/news/',
		nid: 492
	},
	event: {
		label: 'Events',
		title: 'Events & Presentations',
		url: '/resources/events/',
		nid: 558
	},
	asset: {
		label: 'Library',
		title: 'Library',
		url: '/resources/assets/',
		nid: 15258
	}
}

const filters = {
	asset: {
		label: 'Type',
		filters: {
			data_sheet: 'Data Sheet',
			brochure: 'Brochure',
			infographic: 'InfoGraphic',
			video: 'Video',
			podcast: 'Podcast',
			whitepaper: 'Whitepaper',
			poster: 'Poster',
			data_presentation: 'Data Presentation',
			publication: 'Publication'
		}
	},
	news: {
		label: 'Type',
		filters: {
			news: 'News',
			blog: 'Blog'
		}
	},
	news_product: {
		label: 'Product',
		filters: {
			'next-dx': 'NeXT Dx',
			'next-personal': 'NeXT Personal',
			'immunoid-next': 'ImmunoID NeXT',
		}
	},
	asset_product: {
		label: 'Product',
		filters: {
			'next-dx': 'NeXT Dx',
			'next-personal': 'NeXT Personal',
			'immunoid-next': 'ImmunoID NeXT',
		}
	},
	event: {
		label: 'Event Type',
		filters: {
			podium: 'Podium',
			poster: 'Poster',
			eposter: 'ePoster',
			symposium: 'Symposium',
			product_theater: 'Product Theater',
			event_reception: 'Event/Reception'
		}
	}
}

const isMobile = () => {
	if (Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < config.mobileWidth){
		return true
	}
	return false
}

const featuredHitsSwiperConfig = {
	modules: [Navigation, Pagination, Autoplay],
	slidesPerView: 1,
	spaceBetween: 60,
	initialSlide: 0,
	speed: 800,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true
	},
	navigation: {
		prevEl: `.${styles.previous}`,
		nextEl: `.${styles.next}`,
		clickable: true
	},
	pagination: {
		type: 'fraction',
		formatFractionCurrent: (number) => number,
		formatFractionTotal: (number) => number,
		formatFractionSeparator: '/',
		el: `.${styles.pagination}`,
	},
}

const searchClient = algoliasearch('S2ICXJZ8X9', 'b248fbbe179ca55339fb91328a226508');
const index = searchClient.initIndex('Personalis Pages');

function ResourcesSearch(props) {
	const searchWrapperRef = useRef(null)
	const searchContainerRef = useRef(null)
	const hitsContainerRef = useRef(null)
	const paginationContainerRef = useRef(null)
	const tabsWrapperRef = useRef(null)
	const tabsRef = useRef(null)
	const tabOptionsRef = useRef(null)
	const searchRef = useRef(null)
	const optionsDivRef = useRef(null)
	const optionsWrapperRef = useRef(null)
	const filterWrapperRef = useRef(null)
	const eventFiltersRef = useRef(null)
	const eventFiltersWrapperRef = useRef(null)
	const eventFiltersOptionsRef = useRef(null)
	const eventFiltersOptionsWrapperRef = useRef(null)
	const statsRef = useRef(null)
	const [featuredHits, setFeaturedHits, featuredHitsRef] = useStateRef([])
	const [highlightedHit, setHighlightedHit, highlightedHitRef] = useStateRef(null)

	//check if URL has a highlight query
	const [highlight, setHighlight, highlightRef] = useStateRef(null)
	
	/* Event Filters */
	const [eventYears, setEventYears] = useStateRef([])
	const [allEventYears, setAllEventYears] = useStateRef([])
	const [selectedYear, setSelectedYear, selectedYearRef] = useStateRef(null)
	const [allCancerTypes, setAllCancerTypes] = useStateRef([])
	const [selectedCancerType, setSelectedCancerType, selectedCancerTypeRef] = useStateRef(null)
	const [allPartnerStudies, setAllPartnerStudies] = useStateRef([])
	const [selectedPartnerStudy, setSelectedPartnerStudy, selectedPartnerStudyRef] = useStateRef(null)
	const [allProductNames, setAllProductNames] = useStateRef([])
	const [selectedProductName, setSelectedProductName, selectedProductNameRef] = useStateRef(null)
	const [allConferences, setAllConferences] = useStateRef([])
	const [selectedConference, setSelectedConference, selectedConferenceRef] = useStateRef(null)
	/* End Event Filters */

	/* Asset Filters */
	const [assetFiltersOpen, setAssetFiltersOpen, assetFiltersOpenRef] = useStateRef(false)
	/* End Asset Filters */

	/* Product Filters */
	const [newsProductFiltersOpen, setNewsProductFiltersOpen, newsProductFiltersOpenRef] = useStateRef(false)
	const [assetProductFiltersOpen, setAssetProductFiltersOpen, assetProductFiltersOpenRef] = useStateRef(false)
	const [newsProductFilter, setNewsProductFilter, newsProductFilterRef] = useStateRef('')
	const [assetProductFilter, setAssetProductFilter, assetProductFilterRef] = useStateRef('')
	const newsProductOptionsDivRef = useRef(null)
	const newsProductOptionsWrapperRef = useRef(null)
	const assetProductOptionsDivRef = useRef(null)
	const assetProductOptionsWrapperRef = useRef(null)
	/* End Product Filters */

	const doSearchRef = useRef(true)
	

	const [headerData, setHeaderData] = useStateRef({title: props.fields.title, subtitle: props.fields.subtitle, description: props.fields.description})
	const [activeType, setActiveType, activeTypeRef] = useStateRef(props.fields.default_category || 'all')
	const [activeFilters, setActiveFilters, activeFiltersRef] = useStateRef([])
	const [eventActiveFilter, setEventActiveFilter, eventActiveFilterRef] = useStateRef('')
	const [filtersOpen, setFiltersOpen, filtersOpenRef] = useStateRef(false)
	const [eventFiltersOpen, setEventFiltersOpen, eventFiltersOpenRef] = useStateRef(false)
	const [tabsOpen, setTabsOpen, tabsOpenRef] = useStateRef(false)
	const [showArchived, setShowArchived, showArchivedRef] = useStateRef(false)
	const [showFeatured, setShowFeatured, showFeaturedRef] = useStateRef(false)
	const [hoverPreview, setHoverPreview, hoverPreviewRef] = useStateRef({ visible: false, image: '', position: null, hoveredHitId: null })
	const [shouldRenderPreview, setShouldRenderPreview] = useState(true)

	function filterResultsHandler(e) {
		e.preventDefault()
		const type = e.target.dataset.type
		filterResults(type)
		window.history.pushState(type, `Search: ${type}`, types[type].url)
	}

	async function filterResults(type) {
		searchRef.current.helper.state.page = 0
		searchRef.current.helper.state.index = 'replica_date_desc'

		setActiveType(type)
		setActiveFilters([])
		setHighlight(null)
		setHighlightedHit(null)
		searchRef.current.helper.search()

		if(isMobile()){
			toggleTabs(null)
		}

		const pageNid = types[type].nid
		const response = await fetch(`/wp-json/acf/v3/pages/${pageNid}`)
		const responseJson = await response.json()

		const gridFields = get(responseJson, 'acf.grid')
		const searchFields = find(gridFields, {acf_fc_layout: 'search'})

		if (searchFields) {
			setHeaderData({description: searchFields.description, title: searchFields.title, subtitle: searchFields.subtitle})
		}
	}

	function doSearch() {
		doSearchRef.current = true
		searchRef.current.helper.search()
	}

	function popState(e) {
		if (e.state) {
			filterResults(e.state)
		}
	}

	function featured(hit) {
		if (hit.featured && hit.type != 'event' && hit.type != 'new_event') {
			return 'FEATURED'
		}
		return ''
	}

	function buildQueryFilters({
		activeType,
		activeFilters,
		eventActiveFilter,
		showArchived,
		showFeatured,
		selectedYear,
		selectedCancerType,
		selectedPartnerStudy,
		selectedProductName,
		selectedConference,
		highlight,
		newsProductFilter,
		assetProductFilter
	}) {
		let archiveFilter = ''
		let featuredFilter = ''
		let yearFilter = ''
		let cancerTypeFilter = ''
		let partnerStudyFilter = ''
		let productNameFilter = ''
		let conferenceFilter = ''
		let highlightFilter = ''
		let newsProductFilterStr = ''
		let assetProductFilterStr = ''

		if (activeType !== 'event' && activeType !== 'news') {
			archiveFilter = !showArchived ? ' AND archived:false' : ''
		}
	  
		let typeFilter = ''

		if (activeType === 'news') {
			typeFilter = `(type:news OR type:blog)`
		} else if (activeType === 'event') {
			typeFilter = `(type:presentation OR type:new_event)`
		} else if (activeType === 'asset') {
			typeFilter = `(type:asset OR type:data)`
		} else {
			typeFilter = `type:${activeType}`
		}
	  
		let catFilter = '';
		if (activeType === 'news' && activeFilters.length > 0) {
			catFilter = ` AND (${activeFilters.map(filter => `type:${filter}`).join(' OR ')})`
		} else if (activeType === 'event' && eventActiveFilter) {
			if(eventActiveFilter === 'event_reception'){
				catFilter = ` AND (category:reception OR category:event)`
			} else {
				catFilter = ` AND category:${eventActiveFilter}`;
			}
		} else if (activeType === 'asset' && activeFilters.length > 0) {
			catFilter = ` AND (${activeFilters.map(filter => `category:${filter}`).join(' OR ')})`
		}

		if(showFeatured){
			featuredFilter = ' AND featured:true'
		} else {
			featuredFilter = ''
		}

		if (activeType === 'event' && selectedYear) {
			const startOfYear = new Date(selectedYear, 0, 1).getTime() / 1000
			const endOfYear = new Date(selectedYear, 11, 31, 23, 59, 59).getTime() / 1000
			yearFilter = ` AND start_date >= ${startOfYear} AND start_date <= ${endOfYear}`
		}

		if (activeType === 'event' && selectedCancerType) {
			cancerTypeFilter = ` AND cancer_type:"${selectedCancerType}"`
		}

		if (activeType === 'event' && selectedPartnerStudy) {
			partnerStudyFilter = ` AND partner_study:"${selectedPartnerStudy}"`
		}

		if (activeType === 'event' && selectedProductName) {
			productNameFilter = ` AND product:"${selectedProductName}"`
		}

		if (activeType === 'event' && selectedConference) {
			conferenceFilter = ` AND conference:"${selectedConference}"`
		}

		if (activeType === 'news' && newsProductFilter) {
			newsProductFilterStr = ` AND tags:"${newsProductFilter}"`
		}

		if (activeType === 'asset' && assetProductFilter) {
			assetProductFilterStr = ` AND tags:"${assetProductFilter}"`
		}

		if(highlight){
			highlightFilter = ` AND NOT objectID:"${highlight}"`
		}
	  
		if (activeType === 'all') {
			return '(type:news OR type:blog OR type:presentation OR type:new_event OR type:asset OR type:data)' + archiveFilter + featuredFilter + highlightFilter
		}
	  
		return typeFilter + catFilter + archiveFilter + featuredFilter + yearFilter + cancerTypeFilter + partnerStudyFilter + productNameFilter + conferenceFilter + highlightFilter + newsProductFilterStr + assetProductFilterStr
	}

	async function fetchAllEventYears() {
		const response = await searchClient.search([
			{
				indexName: 'replica_order_asc',
				params: {
					hitsPerPage: 1000,
					filters: 'type:presentation OR type:new_event'
				},
			}
		])

		const years = new Set()
		response.results[0].hits.forEach(hit => {
			if (hit.start_date) {
				const year = new Date(hit.start_date * 1000).getFullYear()
				years.add(year)
			}
		})
		setAllEventYears(Array.from(years).sort((a, b) => b - a))
	}

	async function fetchAllCancerTypes() {
		const response = await searchClient.search([
			{
				indexName: 'replica_order_asc',
				params: {
					hitsPerPage: 1000,
					filters: 'type:presentation OR type:new_event'
				},
			}
		])

		const cancerTypes = new Set()
		response.results[0].hits.forEach(hit => {
			if (hit.cancer_type) {
				// Handle both string and array cases
				const types = Array.isArray(hit.cancer_type) ? hit.cancer_type : [hit.cancer_type]
				types.forEach(type => {
					if (type) cancerTypes.add(type.trim()) // Trim whitespace and add non-empty values
				})
			}
		})
		setAllCancerTypes(Array.from(cancerTypes).sort()) // Sort alphabetically for consistent order
	}

	async function fetchAllPartnerStudies() {
		const response = await searchClient.search([
			{
				indexName: 'replica_order_asc',
				params: {
					hitsPerPage: 1000,
					filters: 'type:presentation OR type:new_event'
				},
			}
		])

		const partnerStudies = new Set()
		response.results[0].hits.forEach(hit => {
			if (hit.partner_study) {
				// Handle both string and array cases
				const studies = Array.isArray(hit.partner_study) ? hit.partner_study : [hit.partner_study]
				studies.forEach(study => {
					if (study) partnerStudies.add(study.trim()) // Trim whitespace and add non-empty values
				})
			}
		})
		setAllPartnerStudies(Array.from(partnerStudies).sort()) // Sort alphabetically for consistent order
	}

	async function fetchAllProductNames() {
		const response = await searchClient.search([
			{
				indexName: 'replica_order_asc',
				params: {
					hitsPerPage: 1000,
					filters: 'type:presentation OR type:new_event'
				},
			}
		])

		const productNames = new Set()
		response.results[0].hits.forEach(hit => {
			if (hit.product) {
				const products = Array.isArray(hit.product) ? hit.product : [hit.product]
				products.forEach(product => {
					if (product) productNames.add(product.trim()) 
				})
			}
		})	
		setAllProductNames(Array.from(productNames).sort())
	}

	async function fetchAllConferences() {
		const response = await searchClient.search([
			{
				indexName: 'replica_order_asc',
				params: {
					hitsPerPage: 1000,
					filters: 'type:presentation OR type:new_event'
				},
			}
		])

		const conferences = new Set()
		response.results[0].hits.forEach(hit => {
			if (hit.conference) {
				const confs = Array.isArray(hit.conference) ? hit.conference : [hit.conference]
				confs.forEach(conf => {
					if (conf) conferences.add(conf.trim())
				})
			}
		})
		setAllConferences(Array.from(conferences).sort())
	}

	useEffect(() => {
		function fetchHighlightedHit() {
			index.getObject(highlight).then((hit) => {
				setHighlightedHit(hit)
			})
			.catch(error => {
				console.error('Error fetching highlighted hit:', error)
			})
		}

		if(highlight){
			fetchHighlightedHit()
		}
	}, [highlight])

	useEffect(() => {
		if(highlightedHit){
			const hitElement = document.getElementById(highlightedHit.objectID)
			if(hitElement){
				hitElement.scrollIntoView({ behavior: 'smooth' })
				const readMoreButton = hitElement.querySelector('[data-read-more]')
				if(readMoreButton){
					readMoreButton.click()
				}
			}
		}
	}, [highlightedHit])

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search)
		setHighlight(urlParams.get('highlight') ? urlParams.get('highlight') : null)

		const productParam = urlParams.get('product')
		if (productParam) {
			setAssetProductFilter(productParam)
		}

		const featuredFilters = buildQueryFilters({
			activeType: activeTypeRef.current,
			activeFilters: activeFiltersRef.current,
			eventActiveFilter: eventActiveFilterRef.current,
			showArchived: true,
			showFeatured: true
		})

		function fetchFeaturedHits() {
			searchClient.search([
				{
					indexName: 'replica_date_desc',
					params: {
						hitsPerPage: 1000,
						filters: featuredFilters
					},
				}
			])
			.then(({ results }) => {
				setFeaturedHits(results[0].hits);
			})
		}

		fetchFeaturedHits()
	}, [activeType])

	useEffect(() => {
		document.addEventListener('click', outsideFilterClick)

		return () => {
			document.removeEventListener('click', outsideFilterClick)
		}
	}, [filtersOpen])

	useEffect(() => {
		const input = searchWrapperRef.current.querySelector('input')

		if(input){
			input.addEventListener('focus', focusSearch)
			input.addEventListener('blur', blurSearch)
			
			return () => {
				input.removeEventListener('focus', focusSearch)
				input.removeEventListener('blur', blurSearch)
			}
		}
	}, [searchWrapperRef])

	useEffect(() => {
		if (props.editor) {
			return
		}

		fetchAllEventYears()
		fetchAllCancerTypes()
		fetchAllPartnerStudies()
		fetchAllProductNames()
		fetchAllConferences()

		addEventListener('popstate', popState)

		const search = instantsearch({
			indexName: 'replica_date_desc',
			searchClient,
			searchFunction(helper) {
				const filters = buildQueryFilters({
					activeType: activeTypeRef.current,
					activeFilters: activeFiltersRef.current,
					eventActiveFilter: eventActiveFilterRef.current,
					showArchived: showArchivedRef.current,
					showFeatured: showFeaturedRef.current,
					selectedYear: selectedYearRef.current,
					selectedCancerType: selectedCancerTypeRef.current,
					selectedPartnerStudy: selectedPartnerStudyRef.current,
					selectedProductName: selectedProductNameRef.current,
					selectedConference: selectedConferenceRef.current,
					highlight: highlightRef.current,
					newsProductFilter: newsProductFilterRef.current,
					assetProductFilter: assetProductFilterRef.current
				})

				helper.state.filters = filters;

				if (doSearchRef.current || window.innerWidth > 700) {
					doSearchRef.current = false
					helper.search()
				}
			}
		})
		searchRef.current = search

		const customHits = connectHits(
			(renderOptions, isFirstRender) => {
				const { hits, widgetParams } = renderOptions
				let hitsHtml = ''

				hits.map((hit) => {
					hitsHtml += renderHit(hit)
				})

				widgetParams.container.innerHTML = hitsHtml

				// Add click event handlers for preview buttons
				const previewButtons = widgetParams.container.querySelectorAll(`[data-preview-button]`)
				
				previewButtons.forEach((button) => {
					const hitId = button.getAttribute('data-hit-id')
					const hit = hits.find(h => h.objectID === hitId)
					
					if (hit) {
						button.addEventListener('click', (e) => handlePreviewClick(e, hit))
						button.addEventListener('mouseenter', (e) => handlePreviewMouseEnter(e, hit))
						button.addEventListener('mouseleave', handlePreviewMouseLeave)
						button.addEventListener('mouseout', handlePreviewMouseLeave)
					}
				})
			}
		)

		search.addWidgets([
			configure({
				hitsPerPage: 12,
				filters: 'type:all',
			}),
			pagination({
				container: paginationContainerRef.current,
				cssClasses: {
					selectedItem: styles.selected_page,
					firstPageItem: styles.first_page,
					previousPageItem: styles.previous_page,
					nextPageItem: styles.next_page,
					lastPageItem: styles.last_page,
					disabledItem: styles.disabled_pagination_item
				},
				showFirst: true,
				showLast: true,
				padding: 2,
				scrollTo: hitsContainerRef.current,
				templates: {
					previous: '',
					first: '«',
					last: '»',
					next: '',
				}
			}),
			searchBox({
				container: searchContainerRef.current
			}),
			customHits({
				container: hitsContainerRef.current
			}),
			stats({
				container: statsRef.current,
				templates: {
					text(data, { html }) {
						let totalResults = ''
						let currentResults = ''
						let currentLastResult = data.page * data.hitsPerPage + data.hitsPerPage
				  
						if (data.hasManyResults) {
						  totalResults += `${data.nbHits} results`
						} else if (data.hasOneResult) {
							totalResults += `1 result`
						} else {
							totalResults += `no results`
						}

						if(currentLastResult > data.nbHits){
							currentLastResult = data.nbHits
						}

						if(totalResults && data.nbHits > 1) {
							currentResults = `${data.page * data.hitsPerPage + 1} - ${currentLastResult}`
							return html `Viewing ${currentResults} of <span class="green">${totalResults}</span>`
						} else {
							return html `<span class="green">${totalResults}</span>`
						}
						
					  },
					},
			  })
		])

		search.start()

		initSearchQuery()

		return () => {
			removeEventListener('popstate', popState)
		}
	}, [])

	// Add effect to trigger search when selectedYear changes
	useEffect(() => {
		console.log(selectedProductName)
		if (searchRef.current && (activeTypeRef.current === 'event' || activeTypeRef.current === 'asset')) {
			doSearchRef.current = true
			searchRef.current.helper.search()
		}
	}, [selectedProductName, selectedYearRef.current, selectedCancerTypeRef.current, selectedPartnerStudyRef.current, selectedProductNameRef.current, selectedConferenceRef.current, newsProductFilterRef.current, assetProductFilterRef.current])

	function initSearchQuery() {
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		})
		if (params.query) {
			searchRef.current.helper.state.query = params.query
		}
		if (params.filter) {
			setActiveFilters(params.filter.split(','))
		}
		if (params.product) {
			setAssetProductFilter(params.product)
		}
	}

	function focusSearch(){
		searchWrapperRef.current.classList.add(styles.search_focused)
	}

	function blurSearch(){
		searchWrapperRef.current.classList.remove(styles.search_focused)
	}

	function toggleTabs(e) {
		if (e) {
			e.preventDefault()
		}

		if (tabsOpen) {
			setTabsOpen(false)
			tabsRef.current.style.height = '0px'
			tabsWrapperRef.current.style.height = ''
			tabsWrapperRef.current.classList.remove(styles.expanded)
		} else {
			setTabsOpen(true)
			const height = tabOptionsRef.current.offsetHeight
			tabsRef.current.style.height = height + 'px'
			tabsWrapperRef.current.style.height = height + 100 + 'px'
			tabsWrapperRef.current.classList.add(styles.expanded)
		}
	}

	function toggleFilters(e) {
		if (e) {
			e.preventDefault()
		}

		if (filtersOpen) {
			setFiltersOpen(false)
			optionsWrapperRef.current.style.height = '0px'
			filterWrapperRef.current.style.height = ''
			filterWrapperRef.current.classList.remove(styles.expanded)
		} else {
			setFiltersOpen(true)
			const height = optionsDivRef.current.offsetHeight
			optionsWrapperRef.current.style.height = height + 'px'
			filterWrapperRef.current.style.height = height + 100 + 'px'
			filterWrapperRef.current.classList.add(styles.expanded)
		}
	}

	function toggleEventFilters(e, filterId) {
		if (e) {
			e.preventDefault()
		}

		// Create copy of current state
		const newEventFiltersOpen = {...eventFiltersOpen}
		
		// Toggle state for this specific filter
		newEventFiltersOpen[filterId] = !newEventFiltersOpen[filterId]
		setEventFiltersOpen(newEventFiltersOpen)

		// Get wrapper and options elements for this filter
		const wrapper = document.getElementById(filterId)
		const options = wrapper.querySelector(`.${styles.filter_options}`)

		if (newEventFiltersOpen[filterId]) {
			const height = options.offsetHeight
			wrapper.style.height = height + 'px'
			wrapper.classList.add(styles.expanded)
		} else {
			wrapper.style.height = '40px'
			wrapper.classList.remove(styles.expanded)
		}
	}

	function toggleAssetFilters(e) {
		if (e) {
			e.preventDefault()
		}

		if (assetFiltersOpen) {
			setAssetFiltersOpen(false)
			optionsWrapperRef.current.style.height = '40px'
			optionsWrapperRef.current.classList.remove(styles.expanded)
		} else {
			setAssetFiltersOpen(true)
			const height = optionsDivRef.current.offsetHeight
			optionsWrapperRef.current.style.height = height + 'px'
			optionsWrapperRef.current.classList.add(styles.expanded)
		}
	}

	function toggleNewsProductFilters(e) {
		if (e) {
			e.preventDefault()
		}

		if (newsProductFiltersOpen) {
			setNewsProductFiltersOpen(false)
			newsProductOptionsWrapperRef.current.style.height = '40px'
			newsProductOptionsWrapperRef.current.classList.remove(styles.expanded)
		} else {
			setNewsProductFiltersOpen(true)
			const height = newsProductOptionsDivRef.current.offsetHeight
			newsProductOptionsWrapperRef.current.style.height = height + 'px'
			newsProductOptionsWrapperRef.current.classList.add(styles.expanded)
		}
	}

	function toggleAssetProductFilters(e) {
		if (e) {
			e.preventDefault()
		}

		if (assetProductFiltersOpen) {
			setAssetProductFiltersOpen(false)
			assetProductOptionsWrapperRef.current.style.height = '40px'
			assetProductOptionsWrapperRef.current.classList.remove(styles.expanded)
		} else {
			setAssetProductFiltersOpen(true)
			const height = assetProductOptionsDivRef.current.offsetHeight
			assetProductOptionsWrapperRef.current.style.height = height + 'px'
			assetProductOptionsWrapperRef.current.classList.add(styles.expanded)
		}
	}

	function chooseFilter(e) {
		e.preventDefault()

		const target = e.target
		const filterValue = target.dataset.filter
		const filterType = target.dataset.filterType || 'regular'
		
		if (filterType === 'event') {
			// Handle event filters (keeping single select for events)
			if (eventActiveFilterRef.current === filterValue) {
				setEventActiveFilter('')
			} else {
				setEventActiveFilter(filterValue)
			}
		} else if (filterType === 'news_product') {
			// Handle news product filters
			if (newsProductFilterRef.current === filterValue) {
				setNewsProductFilter('')
			} else {
				setNewsProductFilter(filterValue)
			}
			toggleNewsProductFilters(null)
		} else if (filterType === 'asset_product') {
			// Handle asset product filters
			if (assetProductFilterRef.current === filterValue) {
				setAssetProductFilter('')
			} else {
				setAssetProductFilter(filterValue)
			}
			toggleAssetProductFilters(null)
		} else {
			// Handle regular filters (now single select)
			if (activeFiltersRef.current.includes(filterValue)) {
				// Remove filter if already selected
				setActiveFilters([])
			} else {
				// Replace with single selection
				setActiveFilters([filterValue])
			}
			// Close the dropdown
			toggleAssetFilters(null)
		}
		
		searchRef.current.helper.search()

		if(activeType === 'event'){
			toggleEventFilters(null, 'event_type')
		}
	}

	function outsideFilterClick(e){
		if (filtersOpen && !filterWrapperRef.current.contains(e.target)) {
			e.preventDefault()
			toggleFilters()
		  }
	}

	function toggleArchive() {
		setShowArchived(!showArchived)
		searchRef.current.helper.search()
	}

	function handleYearSelect(year) {
		if (selectedYearRef.current === year) {
			setSelectedYear(null) // Deselect if same year clicked again
			toggleEventFilters(null, 'year')
		} else {
			setSelectedYear(year)
			toggleEventFilters(null, 'year')
		}
	}

	function handleCancerTypeSelect(cancerType) {
		if (selectedCancerTypeRef.current === cancerType) {
			setSelectedCancerType(null) // Deselect if same cancer type clicked again
			toggleEventFilters(null, 'cancer_type')
		} else {
			setSelectedCancerType(cancerType)
			toggleEventFilters(null, 'cancer_type')
		}
	}

	function handlePartnerStudySelect(partnerStudy) {
		if (selectedPartnerStudyRef.current === partnerStudy) {
			setSelectedPartnerStudy(null) // Deselect if same partner study clicked again
			toggleEventFilters(null, 'partner_study')
		} else {
			setSelectedPartnerStudy(partnerStudy)
			toggleEventFilters(null, 'partner_study')
		}
	}

	function handleProductNameSelect(productName) {
		if (selectedProductNameRef.current === productName) {
			setSelectedProductName(null) // Deselect if same product name clicked again
			toggleEventFilters(null, 'product_name')
		} else {
			setSelectedProductName(productName)
			toggleEventFilters(null, 'product_name')
		}
	}

	function handleConferenceSelect(conference) {
		if (selectedConferenceRef.current === conference) {
			setSelectedConference(null) // Deselect if same conference clicked again
			toggleEventFilters(null, 'conference')
		} else {
			setSelectedConference(conference)
			toggleEventFilters(null, 'conference')
		}
	}

	function clearFilters() {
		setActiveFilters([]) // Clear all active filters
		setEventActiveFilter('')
		setNewsProductFilter('')
		setAssetProductFilter('')
		setSelectedConference(null)
		setSelectedYear(null)
		setSelectedCancerType(null)
		setSelectedPartnerStudy(null)
		setSelectedProductName(null)
		searchRef.current.helper.search()
	}

	function closeModal() {
		setHoverPreview({ visible: false, image: '', position: null })
	}

	function openModal(image) {
		setHoverPreview({ visible: true, image: image, position: null })
	}

	function handlePreviewClick(e, hit) {
		e.preventDefault();
		e.stopPropagation();

		// Only show preview for asset types that have images
		const downloadAssetTypes = ['infographic', 'brochure', 'data_sheet', 'whitepaper', 'poster', 'publication', 'data_presentation']
		const categoryValue = Array.isArray(hit.category) ? hit.category[0] : hit.category
		
		if (hit.type === 'asset' || hit.type === 'data') {
			if (downloadAssetTypes.includes(categoryValue?.toLowerCase()) && hit.image) {
				// Get the image URL
				let imageUrl = ''
				if (Array.isArray(hit.image)) {
					imageUrl = hit.image.url || ''
				} else if (hit.image.sizes) {
					imageUrl = hit.image.url || ''
				}
				
				if (imageUrl) {
					const hitElement = e.target.closest(`.${styles.hit}`)
					const resultsContainer = hitsContainerRef.current
					const hitIndex = Array.from(resultsContainer.children).indexOf(hitElement)
					
					const isLeftColumn = hitIndex % 2 === 0
					const targetIndex = isLeftColumn ? hitIndex + 1 : hitIndex - 1
					const targetElement = resultsContainer.children[targetIndex]
					
					if (targetElement) {
						const containerRect = resultsContainer.getBoundingClientRect()
						const isLeftColumn = hitIndex % 2 === 0
						const columnWidth = containerRect.width / 2
						const targetColumnLeft = isLeftColumn 
							? containerRect.left + columnWidth
							: containerRect.left
						
						// Clear existing preview first, then set new one
						setHoverPreview({ visible: false, image: '', position: null, hoveredHitId: null })
						
						// Create a temporary image to get dimensions and determine orientation
						const tempImg = new Image()
						tempImg.onload = function() {
							const isLandscape = this.width > this.height
							const orientationClass = isLandscape ? styles.landscape : styles.portrait

							setHoverPreview({
								visible: true,
								image: imageUrl,
								position: {
									left: targetColumnLeft,
								},
								width: containerRect.width / 2,
								orientationClass: orientationClass,
								hoveredHitId: hit.objectID
							})
						}
						tempImg.src = imageUrl
					}
				}
			}
		}
	}

	function handlePreviewMouseEnter(e, hit) {
		handlePreviewClick(e, hit);
	}

	function handlePreviewMouseLeave() {
		setHoverPreview({ visible: false, image: '', position: null, hoveredHitId: null })
	}

	function renderHit(hit, options = {}) {
		const { isFeatured = false } = options
		let hitsImageHtml = ''
		let hitWrapperOpen = ''
		let hitWrapperClose = ''
		let categories = {}
		let date = ''
		let title = ''
		let tagsHtml = ''
		let readMoreHtml = ''
		let tags = []

		if(hit.type == 'event' || hit.type == 'new_event' || hit.type == 'presentation'){
			if(hit.conference){
				tags.push(hit.conference)
			}

			if(hit.start_date){
				tags.push(new Date(hit.start_date * 1000).toLocaleDateString('en-us', {timeZone:"UTC", year:"numeric"}))
			}

			if(hit.category){
				tags.push(hit.category)
			} else {
				tags.push('Event')
			}

			if(hit.cancer_type){
				tags.push(hit.cancer_type)
			}

			if(hit.partner_study && hit.partner_study?.length > 0){
				tags.push(hit.partner_study)
			}

			if(hit.product && hit.product?.length > 0){
				tags.push(hit.product)
			}
		}

		// Add array of asset types that should show Download button
		const downloadAssetTypes = ['infographic', 'brochure', 'data_sheet', 'whitepaper', 'poster', 'publication', 'data_presentation']
		
		// Add array of types that should show excerpt/description/content
		const showContentTypes = ['event', 'presentation', 'new_event', 'blog']

		function category(hit) {
			if (hit.type == 'news') {
				return 'News'
			}
			
			if (hit.type == 'blog') {
				return 'Blog'
			}
		
			if (hit.type == 'page') {
				return 'Page'
			}

			if(hit.type == 'new_event'){
				return 'Event'
			}

			if(hit.type == 'presentation'){
				return hit.category
			}
		
			if (hit.category && categories[hit.category]) {
				return categories[hit.category]
			}
		
			if (hit.type && types[hit.type]) {
				return types[hit.type].label
			}
		
			return ''
		}

		each(filters, (value, key) => {
			categories = merge(categories, value.filters)
		})

		if (hit.type == 'event' || hit.type == 'presentation' || hit.type == 'new_event') {
			if(!hit.start_date){
				date = new Date(hit.published_gmt * 1000).toLocaleDateString('en-us', {timeZone:"UTC", year:"numeric", month:"long", day:"numeric"})
			} else if (hit.start_date == hit.end_date || hit.start_date && !hit.end_date || new Date(hit.start_date * 1000).toLocaleDateString('en-us', {timeZone:"UTC", year:"numeric", month:"long", day:"numeric"}) == new Date(hit.end_date * 1000).toLocaleDateString('en-us', {timeZone:"UTC", year:"numeric", month:"long", day:"numeric"})){
				date = new Date(hit.start_date * 1000).toLocaleDateString('en-us', {timeZone:"UTC", year:"numeric", month:"long", day:"numeric"})
			} else {
				date = `${new Date(hit.start_date * 1000).toLocaleDateString('en-us', {timeZone:"UTC", month:"long", day:"numeric"})} - ${new Date(hit.end_date * 1000).toLocaleDateString('en-us', {timeZone:"UTC", year:"numeric", month:"long", day:"numeric"})}`
			}
		} else {
			date = new Date(hit.published_gmt * 1000).toLocaleDateString('en-us', {timeZone:"UTC", year:"numeric", month:"long", day:"numeric"})
		}

		if(hit.type == 'new_event'){
			hit.subtitle = `${hit.location}`
		}

		if(hit.type == 'presentation'){
			title = `<span class="${styles.abstract}">${hit.abstract_number ? '[' + hit.abstract_number + ']' : ''} </span> ${hit.title}`
			readMoreHtml = `<div class="${styles.read_more_wrapper}" style="height: 0px; overflow: hidden;">
				<div class="${styles.read_more_contents}">
				${hit.read_more.content ? `<div class="${styles.content}">${hit.read_more.content}</div>` : ''}
				${hit.read_more.track ? `<div class="${styles.track}"><strong>Track:</strong> ${hit.read_more.track}</div>` : ''}
				${hit.read_more.authors ? `<div class="${styles.authors}"><strong>Lead/Authors:</strong> ${hit.read_more.authors}</div>` : ''}
				${hit.read_more.presenters ? `<div class="${styles.presenters}">${hit.read_more.presenters.map(presenter => 
					`<div class="${styles.presenter}">
						<div class="${styles.presenter_image}">
							<img src="${presenter.image.sizes.medium_large}" width="${presenter.image.sizes['medium_large-width']}" height="${presenter.image.sizes['medium_large-height']}" />
						</div>
						<div class="${styles.presenter_content}">
							<div class="${styles.presenter_name}">${presenter.name}</div>
							<div class="${styles.presenter_title}">${presenter.title}</div>
							<div class="${styles.presenter_bio}">${presenter.bio}</div>
						</div>
					</div>`).join('')}</div>` : ''}
				</div>
			</div>`
			hit.subtitle = hit.location + ', ' + hit.time
			if(activeTypeRef.current === 'all') {
				hitWrapperOpen = `<div class="${styles.hit_wrapper}"><a id="${isFeatured ? '' : hit.objectID}" class="${styles.hit} ${styles[hit.type] || ''} ${styles[(hit.category?.toLowerCase().replace(/\s+/g, '-'))] || ''} ${hit.classes || ''} ${hit.featured ? styles.featured : ''} ${isFeatured ? styles.featured_hit : ''}" href="/resources/events?highlight=${hit.objectID}">`
				hitWrapperClose = '</a></div>'
			} else {
				hitWrapperOpen = `<div id="${isFeatured ? '' : hit.objectID}" class="${styles.hit} ${styles[hit.type] || ''} ${styles[(hit.category?.toLowerCase().replace(/\s+/g, '-'))] || ''} ${hit.classes || ''} ${hit.featured ? styles.featured : ''} ${isFeatured ? styles.featured_hit : ''}"
				${readMoreHtml && `style="cursor: pointer;" onclick="(function(e) {
					if(e.target.closest('[data-read-more]')) return false;
					const readMore = e.target.closest('.${styles.hit}').querySelector('[data-read-more]');
					readMore.click();
					})(event)"`}
				>`
				hitWrapperClose = '</div>'
			}
			hitsImageHtml = `<div class="${styles.placeholder}"></div>`
		} else {
			hitWrapperOpen = `<a id="${hit.objectID}" class="${styles.hit} ${styles[hit.type] || ''} ${isFeatured ? styles.featured_hit : ''} ${hit.type !== 'blog' || activeTypeRef.current === 'all' ? styles[hit.category] || '' : ''} ${hit.classes || ''} ${hit.featured ? styles.featured : ''}" href="${hit.download_path || hit.path}" target="${hit.download_path ? '_blank' : hit.target}">`
			hitWrapperClose = '</a>'
		}

		// If this is a download type, use the static SVG
		if (hit.type == 'asset' || hit.type == 'data' ) {
			hitsImageHtml = `<img src="/wp-content/themes/personalis/assets/resources/${hit.category}.svg" alt="${hit.category}" class="${styles.placeholder}" />`
		} else if(hit.image && !hit.image.length && hit.type != 'presentation'){
			if(hit.image.sizes && hit.image.sizes.medium_large){
				hitsImageHtml = `<img src="${hit.image.sizes.medium_large}" width="${hit.image.sizes['medium_large-width'] || ''}" height="${hit.image.sizes['medium_large-height'] || ''}" class="${(hit.image.id == '16277' || hit.image.id == '16276' || hit.image.id == '16275' || hit.image.id == '17790' ? styles.placeholder : '')}" />`
			}
		} else if(hit.image && hit.image.length > 0 && hit.type != 'presentation'){
			hit.image.map((image, i) => {
				if (image && image.sizes && image.sizes.medium_large) {
					hitsImageHtml += `<img src="${image.sizes.medium_large}" width="${image.sizes['medium_large-width'] || ''}" height="${image.sizes['medium_large-height'] || ''}" class="${(image.id == '16277' || image.id == '16276' || image.id == '16275' || image.id == '17790' ? styles.placeholder : '')}" />`
				}
			})
		}

		if(hit.type == 'news' || hit.type == 'blog') {
			// If it's a news item or blog post, add the FPO image as an overlay
			if(hit.image && !hit.image.length && hit.image.sizes && hit.image.sizes.medium_large) {
				hitsImageHtml = `
					<div class="${styles.image_container}">
						<img src="${hit.image.sizes.medium_large}" width="${hit.image.sizes['medium_large-width'] || ''}" height="${hit.image.sizes['medium_large-height'] || ''}" />
					</div>`
			} else if(hit.image && hit.image.length > 0) {
				hitsImageHtml = hit.image.map((image, i) => {
					if (image && image.sizes && image.sizes.medium_large) {
						return `
							<div class="${styles.image_container}">
								<img src="${image.sizes.medium_large}" width="${image.sizes['medium_large-width'] || ''}" height="${image.sizes['medium_large-height'] || ''}" />
							</div>`
					}
				}).join('')
			}
		}

		if(tags){
			tagsHtml = tags.map(tag => `<span class="${styles.tag}">${tag}</span>`).join('')
		}

		if(hit.type != 'presentation'){
			title = hit.title
		}

		const featuredLabel = featured(hit) ? `<span class="${styles.category} ${styles.featured_label}">${featured(hit)}</span>` : ''

		// Modify the button section to include View button for download types
		let showDownloadButton = false
		let showViewButton = false
		let imageUrl = ''
		
		if(hit?.category){
			// Handle both string and array cases for category
			const categoryValue = Array.isArray(hit.category) ? hit.category[0] : hit.category
			if (typeof categoryValue === 'string') {
				showDownloadButton = downloadAssetTypes.includes(categoryValue.toLowerCase())

				if(hit.type == 'blog'){
					showDownloadButton = false
				}
			
				// Only show view button if there's an image
				if (showDownloadButton && hit.image) {
					showViewButton = true
					// Get the first image URL if it's an array
					if (Array.isArray(hit.image)) {
						imageUrl = hit.image[0]?.sizes?.medium_large || ''
					} else if (hit.image.sizes) {
						imageUrl = hit.image.sizes.medium_large || ''
					}
				}
			}
		}
		
		const buttonsHtml = hit.type === 'presentation'
			? activeTypeRef.current === 'all'
				? `<span class="${styles.read_more}">Read More</span>`
				: `<div class="${styles.button_group}">
					<span data-read-more class="${styles.read_more}" onclick="(function(e) {
						const wrapper = e.target.closest('.${styles.hit}').querySelector('.${styles.read_more_wrapper}');
						const isExpanded = wrapper.style.height !== '0px';
						wrapper.style.height = isExpanded ? '0px' : wrapper.scrollHeight + 'px';
						e.target.textContent = isExpanded ? 'Read More' : 'Read Less';
					})(event)">Read More</span>
					${hit.call_to_action?.url ? `<a href="${hit.call_to_action.url}" target="${hit.call_to_action.target || '_self'}" class="${styles.call_to_action_link}">${hit.call_to_action.title || 'Learn More'}</a>` : ''}
				</div>`
			: `<div class="${styles.button_group}">
				<span class="${styles.read_more}">${showDownloadButton ? 'View & Download' : 'Read More'}</span>
				${showViewButton ? `<span class="${styles.preview_button}" data-preview-button data-hit-id="${hit.objectID}">Preview</span>` : ''}
			</div>`;

		// Modify the description section to only show content for specific types
		const showContent = showContentTypes.includes(hit.type)
		const contentHtml = showContent 
			? `<p>${hit.excerpt || hit.meta_description || hit.content || ''}</p>`
			: ''

		return `${hitWrapperOpen}
			${hitsImageHtml ? `<div class="${styles.image_wrapper} ${styles[`count_${hit.image?.length}`]}">
				${hitsImageHtml}
			</div>` : ''}
			<div class="${styles.hit_content}">
				<div class="${styles.hit_header}">
					<span class="${styles.date}">${date}</span>
					${hit.type !== 'blog' || activeTypeRef.current === 'all' ? `${category(hit) ? ' | ' : ''} <span class="${styles.category}">${category(hit)}</span>${featuredLabel ? ' | ' : ''}` : ''}
					${featuredLabel}
				</div>
				<div class="${styles.description}">
					<h3>${title}</h3>
					${hit.subtitle ? `<h4>${hit.subtitle}</h4>` : ''}
					${contentHtml}
				</div>
				${readMoreHtml}
				<div class="${styles.tags_wrapper}">${tagsHtml}</div>
				${buttonsHtml}
			</div>
		${hitWrapperClose}`
	}

	useEffect(() => {
		function handleOpenModal(e) {
			setHoverPreview({ visible: true, image: e.detail, position: null })
		}

		window.addEventListener('openModal', handleOpenModal)
		return () => {
			window.removeEventListener('openModal', handleOpenModal)
		}
	}, [])

	// Update hover classes when hoverPreview state changes
	useEffect(() => {
		if (hitsContainerRef.current) {
			const hitElements = hitsContainerRef.current.querySelectorAll(`.${styles.hit}`)
			
			hitElements.forEach((element) => {
				const hitId = element.id
				
				if (hoverPreviewRef.current.visible && hoverPreviewRef.current.hoveredHitId === hitId) {
					// Add hovered class to the current hit
					element.classList.add(styles.hovered)
					element.classList.remove(styles.not_hovered)
				} else if (hoverPreviewRef.current.visible && hoverPreviewRef.current.image) {
					// Add not_hovered to ALL items that aren't currently being hovered
					element.classList.add(styles.not_hovered)
					element.classList.remove(styles.hovered)
				} else {
					// No hover active or no preview image - remove all classes
					element.classList.remove(styles.hovered, styles.not_hovered)
				}
			})
		}
	}, [hoverPreviewRef.current.visible, hoverPreviewRef.current.hoveredHitId, hoverPreviewRef.current.image, hoverPreviewRef.current.width])

	return props.editor ? <div>Search Component</div> : <div ref={searchWrapperRef} className={styles.search_wrapper}>

		<Title fields={{heading_type: 'h1', title: headerData.title, subtitle: headerData.subtitle}} />
		<Wysiwyg className={styles.intro} fields={{content: headerData.description}} />

		<br />

		<div ref={tabsWrapperRef} className={styles.tabs_wrapper}>
			<h2><span>Category: </span><div onClick={toggleTabs} className={styles.filter_value}>{types[activeType]?.title}</div></h2>
			<div ref={tabsRef} className={styles.tabs}>
				<div ref={tabOptionsRef} className={styles.tab_options}>
					{Object.keys(types).map((type, i) => {
						return <button key={`type_${i}`} className={activeType == type ? styles.active : ''} onClick={filterResultsHandler} data-type={type}>{types[type].title}</button>
					})}
				</div>
			</div>
		</div>
		
		{activeType == 'event' && <div ref={eventFiltersRef} className={styles.event_filters}>
			<div ref={eventFiltersWrapperRef} id="conference" className={styles.filter_options_wrapper}>
				<div ref={eventFiltersOptionsRef} className={styles.filter_options}>
					<div onClick={() => toggleEventFilters(null, 'conference')} className={styles.filter_value}>
						{selectedConferenceRef.current ? `${selectedConferenceRef.current}` : 'Conference'}
					</div>
					{allConferences.map((conference, i) => (
						<button 
							key={`conference_${i}`} 
							onClick={() => handleConferenceSelect(conference)}
							className={selectedConferenceRef.current === conference ? styles.active : ''}
						>
							{conference}
						</button>
					))}
				</div>
			</div>

			<div ref={eventFiltersWrapperRef} id="year" className={styles.filter_options_wrapper}>
				<div ref={eventFiltersOptionsRef} className={styles.filter_options}>
					<div onClick={() => toggleEventFilters(null, 'year')} className={styles.filter_value}>
						{selectedYearRef.current ? `${selectedYearRef.current}` : 'Year'}
					</div>
					{allEventYears.map((year, i) => (
						<button 
							key={`year_${i}`} 
							onClick={() => handleYearSelect(year)}
							className={selectedYearRef.current === year ? styles.active : ''}
						>
							{year}
						</button>
					))}
				</div>
			</div>

			<div ref={eventFiltersWrapperRef} id="event_type" className={styles.filter_options_wrapper}>
				<div ref={eventFiltersOptionsRef} className={styles.filter_options}>
					<div onClick={() => toggleEventFilters(null, 'event_type')} className={styles.filter_value}>
						{eventActiveFilter 
							? filters[activeType].filters[eventActiveFilter]
							: filters[activeType].label}
					</div>
					{Object.keys(filters[activeType].filters).map((key, i) => (
						<button 
							onClick={chooseFilter} 
							data-filter={key} 
							data-filter-type="event" 
							key={`filter_${i}`}
							className={eventActiveFilter === key ? styles.active : ''}
						>
							{filters[activeType].filters[key]}
						</button>
					))}
				</div>
			</div>
		
			<div ref={eventFiltersWrapperRef} id="cancer_type" className={styles.filter_options_wrapper}>
				<div ref={eventFiltersOptionsRef} className={styles.filter_options}>
					<div onClick={() => toggleEventFilters(null, 'cancer_type')} className={styles.filter_value}>
						{selectedCancerTypeRef.current ? `${selectedCancerTypeRef.current}` : 'Cancer Type'}
					</div>
					{allCancerTypes.map((cancerType, i) => (
						<button 
							key={`cancer_type_${i}`} 
							onClick={() => handleCancerTypeSelect(cancerType)}
							className={selectedCancerTypeRef.current === cancerType ? styles.active : ''}
						>
							{cancerType}
						</button>
					))}
				</div>
			</div>
					
			{allPartnerStudies.length > 0 && (
			<div ref={eventFiltersWrapperRef} id="partner_study" className={styles.filter_options_wrapper}>
				<div ref={eventFiltersOptionsRef} className={styles.filter_options}>
					<div onClick={() => toggleEventFilters(null, 'partner_study')} className={styles.filter_value}>
						{selectedPartnerStudyRef.current ? `${selectedPartnerStudyRef.current}` : 'Partner/Study'}
					</div>
					{allPartnerStudies.map((partnerStudy, i) => (
						<button 
							key={`partner_study_${i}`} 
							onClick={() => handlePartnerStudySelect(partnerStudy)}
							className={selectedPartnerStudyRef.current === partnerStudy ? styles.active : ''}
						>
							{partnerStudy}
						</button>
					))}
				</div>
			</div>
			)}

			<div ref={eventFiltersWrapperRef} id="product_name" className={styles.filter_options_wrapper}>
				<div ref={eventFiltersOptionsRef} className={styles.filter_options}>
					<div onClick={() => toggleEventFilters(null, 'product_name')} className={styles.filter_value}>
						{selectedProductNameRef.current ? `${selectedProductNameRef.current}` : 'Product'}
					</div>
					{allProductNames.map((productName, i) => (
						<button 
							key={`product_name_${i}`} 
						onClick={() => handleProductNameSelect(productName)}
						className={selectedProductNameRef.current === productName ? styles.active : ''}
					>
						{productName}
						</button>
					))}
				</div>
			</div>

			{(selectedConference || selectedYear || selectedCancerType || selectedPartnerStudy || selectedProductName || eventActiveFilter) && 
				<button className={styles.clear_filters} onClick={() => clearFilters()}>Clear Filters</button>
			}
				
		</div>}

		{activeType && filters[activeType] && activeType !== 'event' && (
			<div className={styles.filter_wrapper} ref={filterWrapperRef}>
				<div className={styles.filter_options_wrapper} ref={optionsWrapperRef}>
					<div className={styles.filter_options} ref={optionsDivRef}>
						<div onClick={toggleAssetFilters} className={styles.filter_value}>
							{activeFiltersRef.current.length > 0 
								? filters[activeType].filters[activeFiltersRef.current[0]]
								: filters[activeType].label}
						</div>
						{Object.keys(filters[activeType].filters).map((key, i) => (
							<button 
								onClick={chooseFilter} 
								data-filter={key} 
								data-filter-type="regular" 
								key={`filter_${i}`}
								className={activeFiltersRef.current.includes(key) ? styles.active : ''}
							>
								{filters[activeType].filters[key]}
							</button>
						))}
					</div>
				</div>

				{activeType === 'news' && (
					<div className={styles.filter_options_wrapper} ref={newsProductOptionsWrapperRef}>
						<div className={styles.filter_options} ref={newsProductOptionsDivRef}>
							<div onClick={toggleNewsProductFilters} className={styles.filter_value}>
								{newsProductFilterRef.current 
									? filters.news_product.filters[newsProductFilterRef.current]
									: filters.news_product.label}
							</div>
							{Object.keys(filters.news_product.filters).map((key, i) => (
								<button 
									onClick={chooseFilter} 
									data-filter={key} 
									data-filter-type="news_product" 
									key={`news_product_filter_${i}`}
									className={newsProductFilterRef.current === key ? styles.active : ''}
								>
									{filters.news_product.filters[key]}
								</button>
							))}
						</div>
					</div>
				)}

				{activeType === 'asset' && (
					<div className={styles.filter_options_wrapper} ref={assetProductOptionsWrapperRef}>
						<div className={styles.filter_options} ref={assetProductOptionsDivRef}>
							<div onClick={toggleAssetProductFilters} className={styles.filter_value}>
								{assetProductFilterRef.current 
									? filters.asset_product.filters[assetProductFilterRef.current]
									: filters.asset_product?.label}
							</div>
							{Object.keys(filters.asset_product?.filters || {}).map((key, i) => (
								<button 
									onClick={chooseFilter} 
									data-filter={key} 
									data-filter-type="asset_product" 
									key={`asset_product_filter_${i}`}
									className={assetProductFilterRef.current === key ? styles.active : ''}
								>
									{filters.asset_product?.filters[key]}
								</button>
							))}
						</div>
					</div>
				)}

				{(activeFiltersRef.current.length > 0 || newsProductFilterRef.current || assetProductFilterRef.current) && 
					<button className={styles.clear_filters} onClick={() => clearFilters()}>Clear Filters</button>
				}
			</div>
		)}

		<div className={styles.search_bar_wrapper}>
			<div ref={searchContainerRef} className={classNames(styles.search_container, !filters[activeType] && activeType !== 'asset' ? styles.no_filters : '')}>
				<h2><span>Search:</span></h2>
			</div>
		</div>

		{activeType != 'event' && activeType != 'news' && <div onClick={toggleArchive} className={classNames(styles.archive_toggle_wrapper, showArchived ? styles.active : '')}>
			<button className={styles.archive_toggle_element} aria-label='Include archived content toggle'></button>
			<label>Include archived content</label>
		</div>}

		<button onClick={doSearch} className={classNames(styles.mobile_search_submit, 'mobile_only')}>Submit</button>

		<div ref={statsRef} className={styles.stats}></div>
						
		{featuredHits.length > 0 && activeType !== 'all' && (
			<div className={styles.featured_slider}>
				<Swiper 
					key={`featured-swiper-${featuredHits.length}`}
					{...featuredHitsSwiperConfig} 
					loop={featuredHits.length > 1} 
					navigation={featuredHits.length > 1 ? featuredHitsSwiperConfig.navigation : false}
					onSlideChange={() => {
						// Find any expanded read more sections in the current slide and collapse them
						const currentSlide = document.querySelector('.swiper-slide-active');
						if (currentSlide) {
							const expandedWrappers = currentSlide.querySelectorAll(`.${styles.read_more_wrapper}[style*="height:"]`);
							const expandedButtons = currentSlide.querySelectorAll(`.${styles.read_more}[data-read-more]`);
							expandedWrappers.forEach(wrapper => {
								if (wrapper.style.height !== '0px') {
									wrapper.style.height = '0px';
								}
							});
							expandedButtons.forEach(button => {
								if (button.textContent === 'Read Less') {
									button.textContent = 'Read More';
								}
							});
						}
					}}
				>
					{featuredHits.map(item => (
						<SwiperSlide key={item.objectID}>
							<div dangerouslySetInnerHTML={{ __html: renderHit(item, { isFeatured: true }) }} />
						</SwiperSlide>
					))}
					<div className={styles.pagination_container}>
						<div className={styles.pagination}></div>
						<div className={styles.navigation}>
							<button aria-label='previous' className={styles.previous} disabled={featuredHits.length <= 1}></button>
							<button aria-label='next' className={styles.next} disabled={featuredHits.length <= 1}></button>
						</div>
					</div>
				</Swiper>
			</div>
		)}

		{highlightedHit && (
			<div className={`${styles.highlighted_hit} ${styles.results} ${styles[`${activeType}_results`]} ${styles[`${eventActiveFilter}_results`]}`} dangerouslySetInnerHTML={{ __html: renderHit(highlightedHit) }}>
			</div>
		)}

		<div ref={hitsContainerRef} className={`${styles.results} ${styles[`${activeType}_results`]} ${styles[`${eventActiveFilter}_results`]} ${hoverPreviewRef.current.visible ? styles.hover_active : ''}`}>
		</div>

		{/* Hover Preview Component - Always rendered, uses opacity for fade in/out */}
		<div 
			className={`${styles.hover_preview} ${hoverPreviewRef.current.visible ? styles.visible : ''} ${hoverPreviewRef.current.orientationClass}`}
			style={{
				top: hoverPreviewRef.current.position?.top || 0,
				left: hoverPreviewRef.current.position?.left || 0,
				width: hoverPreviewRef.current.width || 'auto',
				opacity: hoverPreviewRef.current.visible ? 1 : 0,
				transition: 'opacity 0.3s ease-in-out',
				pointerEvents: hoverPreviewRef.current.visible ? 'auto' : 'none'
			}}
		>
			{hoverPreviewRef.current.image && (
				<img src={hoverPreviewRef.current.image} alt="Preview" />
			)}
		</div>

		<div className={styles.pagination_container} ref={paginationContainerRef}>

		</div>
	</div>
}

export default ResourcesSearch